import React, {useEffect, useState} from "react";
import axios from "axios";
import Swal from "sweetalert2";
import ERPDataGrid from "../ERPDataGrid";
import "../ERPTheme.css";
import {baseUrl, ipAddress, userName,} from "../Univ";
import "bootstrap/dist/css/bootstrap.min.css";
function GoodsIssue() {
    const [loading, setLoading] = useState(false);
    const [rows, setRows] = useState([]);
    const [warehouseList, setWarehouseList] = useState([]);
    const [workerList, setWorkerList] = useState([]);
    const [editId, setEditId] = useState(null);
    const [formData, setFormData] = useState({
        issue_no: "",
        issue_date: "",
        warehouse: "",
        issued_to: "",
        purpose: "",
        remarks: "",
        status: 1,
        addedby: userName,
        ip_add: ipAddress,
    });
    useEffect(() => {
        getWarehouse();
        getWorkers();
        getGoodsIssue();
    }, []);
    const getWarehouse = () => {
        axios
            .get(baseUrl + "warehouse/")
            .then((res) => {
                setWarehouseList(res.data);
            });
    };
    const getWorkers = () => {
        axios
            .get(baseUrl + "worker/create/")
            .then((res) => {
                setWorkerList(res.data);
            });
    };
    const getGoodsIssue = () => {
        setLoading(true);
        axios
            .get(baseUrl + "goods-issue/")
            .then((res) => {
                setRows(res.data);
                setLoading(false);
            })
            .catch(() => {
                setLoading(false);
                Swal.fire({
                    icon: "error", title: "Error", text: "Unable to load Goods Issue records.",
                });
            });
    };
    const handleChange = (e) => {
        const {name, value} = e.target;
        setFormData({
            ...formData, [name]: value,
        });
    };
    const clearForm = () => {

    setEditId(null);

    setFormData({
        issue_no: "",
        issue_date: "",
        warehouse: "",
        issued_to: "",
        purpose: "",
        remarks: "",
        status: 1,
        addedby: userName,
        ip_add: ipAddress,
    });

};
const editGoodsIssue = async (row) => {

    setEditId(row.id);

    setFormData({
        issue_no: row.issue_no,
        issue_date: row.issue_date,
        warehouse: row.warehouse.id,
        issued_to: row.issued_to,
        purpose: row.purpose,
        remarks: row.remarks,
        status: row.status,
        addedby: userName,
        ip_add: ipAddress,
    });

    await axios.get(
        baseUrl + `update-goods-issue/${row.id}/`
    );

};
const saveGoodsIssue = () => {

    const data = new FormData();

    data.append("issue_no", formData.issue_no);
    data.append("issue_date", formData.issue_date);
    data.append("warehouse", formData.warehouse);
    data.append("issued_to", formData.issued_to);
    data.append("purpose", formData.purpose);
    data.append("remarks", formData.remarks);
    data.append("status", formData.status);
    data.append("addedby", userName);
    data.append("ip_add", ipAddress);

    setLoading(true);

    const request =
        editId === null
            ? axios.post(baseUrl + "goods-issue/", data)
            : axios.put(
                  baseUrl + `update-goods-issue/${editId}/`,
                  data
              );

    request
        .then(() => {

            Swal.fire({
                icon: "success",
                title: "Success",
                text:
                    editId === null
                        ? "Goods Issue saved successfully."
                        : "Goods Issue updated successfully.",
            });

            clearForm();
            getGoodsIssue();

        })
        .catch(() => {

            setLoading(false);

            Swal.fire({
                icon: "error",
                title: "Error",
                text: "Unable to save Goods Issue.",
            });

        });

};
const deleteGoodsIssue = (id) => {

    Swal.fire({
        title: "Delete Goods Issue?",
        text: "You won't be able to revert this.",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes",
    }).then((result) => {

        if (result.isConfirmed) {

            setLoading(true);

            axios
                .delete(baseUrl + `update-goods-issue/${id}/`)
                .then(() => {

                    Swal.fire({
                        icon: "success",
                        title: "Deleted",
                        text: "Goods Issue deleted successfully.",
                    });

                    getGoodsIssue();

                })
                .catch(() => {

                    setLoading(false);

                    Swal.fire({
                        icon: "error",
                        title: "Error",
                        text: "Unable to delete Goods Issue.",
                    });

                });

        }

    });

};
    const columns = [{
        field: "id", headerName: "ID", width: 80,
    }, {
        field: "issue_no", headerName: "Issue No", width: 150,
    }, {
        field: "issue_date", headerName: "Issue Date", width: 140,
    }, {
        field: "warehouse_name", headerName: "Warehouse", flex: 1,
         renderCell: (params) => (params.row.warehouse?.warehouse_name)
    }, {
        field: "issued_to_name", headerName: "Issued To", flex: 1,
        renderCell: (params) => (params.row.issued_to?.name)
    }, {
        field: "purpose", headerName: "Purpose", width: 180,
    }, {
        field: "status",
        headerName: "Status",
        width: 100,
        renderCell: (params) => params.value === 1 ? "Active" : "Inactive",
    },
    {
    field: "action",
    headerName: "Action",
    width: 180,
    sortable: false,
    renderCell: (params) => (
        <>
            <button
                className="btn btn-success btn-sm me-2"
                onClick={() => editGoodsIssue(params.row)}
            >
                Edit
            </button>

            <button
                className="btn btn-danger btn-sm"
                onClick={() => deleteGoodsIssue(params.row.id)}
            >
                Delete
            </button>
        </>
    ),
},
    ];
    return (
        <div className="container-fluid mt-3">

            <div className="card shadow">

                <div className="card-header bg-primary text-white">

                    <h5 className="mb-0">
                        Goods Issue
                    </h5>

                </div>

                <div className="card-body">

                    <div className="row">

                        <div className="col-md-3 mb-3">

                            <label>Issue No</label>

                            <input
                                type="text"
                                className="form-control"
                                name="issue_no"
                                value={formData.issue_no}
                                onChange={handleChange}
                            />

                        </div>

                        <div className="col-md-3 mb-3">

                            <label>Issue Date</label>

                            <input
                                type="date"
                                className="form-control"
                                name="issue_date"
                                value={formData.issue_date}
                                onChange={handleChange}
                            />

                        </div>

                        <div className="col-md-3 mb-3">

                            <label>Warehouse</label>

                            <select
                                className="form-select"
                                name="warehouse"
                                value={formData.warehouse}
                                onChange={handleChange}
                            >

                                <option value="">
                                    Select Warehouse
                                </option>

                                {warehouseList.map((item) => (
                                    <option
                                        key={item.id}
                                        value={item.id}
                                    >
                                        {item.warehouse_name}
                                    </option>
                                ))}

                            </select>

                        </div>

                        <div className="col-md-3 mb-3">

                            <label>Issued To</label>

                            <select
                                className="form-select"
                                name="issued_to"
                                value={formData.issued_to}
                                onChange={handleChange}
                            >

                                <option value="">
                                    Select Worker
                                </option>

                                {workerList.map((item) => (
                                    <option
                                        key={item.id}
                                        value={item.id}
                                    >
                                        {item.name}
                                    </option>
                                ))}

                            </select>

                        </div>

                        <div className="col-md-6 mb-3">

                            <label>Purpose</label>

                            <input
                                type="text"
                                className="form-control"
                                name="purpose"
                                value={formData.purpose}
                                onChange={handleChange}
                            />

                        </div>

                        <div className="col-md-6 mb-3">

                            <label>Remarks</label>

                            <textarea
                                className="form-control"
                                rows="2"
                                name="remarks"
                                value={formData.remarks}
                                onChange={handleChange}
                            />

                        </div>

                        <div className="col-md-2 mb-3">

                            <label>Status</label>

                            <select
                                className="form-select"
                                name="status"
                                value={formData.status}
                                onChange={handleChange}
                            >
                                <option value={1}>Active</option>
                                <option value={0}>Inactive</option>
                            </select>

                        </div>

                        <div className="col-md-12 mt-3">

                            <button
                                className="btn btn-success me-2"
                                onClick={saveGoodsIssue}
                                disabled={loading}
                            >
                                Save
                            </button>

                            <button
                                className="btn btn-secondary"
                                onClick={clearForm}
                            >
                                Clear
                            </button>

                        </div>

                    </div>
                    <div className="card shadow mt-3">

                        <div className="card-header bg-primary text-white">

                            <h5 className="mb-0">
                                Goods Issue List
                            </h5>

                        </div>

                        <div className="card-body">

                            <div
                                style={{
                                    height: 600, width: "100%",
                                }}
                            >

                                <ERPDataGrid
                                    rows={rows}
                                    columns={columns}
                                    loading={loading}
                                    getRowId={(row) => row.id}
                                    pageSizeOptions={[10, 25, 50, 100,]}
                                    
                                    disableRowSelectionOnClick
                                />

                            </div>

                        </div>

                    </div>

                </div>

            </div>

        </div>
    );
}
export default GoodsIssue;